module.exports = __webpack_public_path__ + "static/media/az-min.9f5b5ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/az-min.svg
// module id = 691
// module chunks = 0